const scandia_org = "aaa9a975-fbcb-41b4-a2dd-3f404f6920a1";

export const paymentEnabled = (env, company) => {
  try {
    if (company?.features?.enableVismaPay) {
      return true;
    }
    // Old way of checking from Env variable. TODO: Completely replace with check from above
    if (company?.group) {
      const featureGroups = process.env.REACT_APP_FEATURE_PAYMENT.split(" ");
      const enabled = featureGroups.includes(company.group);
      return enabled;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const strongAuthEnabled = (env, group) => {
  if (env === "local" || env === "dev" || env === "staging" || env === "dev2")
    return true;
  try {
    const featureGroups = process.env.REACT_APP_FEATURE_SIGN.split(" ");
    const enabled = featureGroups.includes(group);
    return enabled;
  } catch (e) {
    return false;
  }
};

export const enableProductTypeCategories = (organizationId) => {
  const featureOrganizations = ["aaa9a975-fbcb-41b4-a2dd-3f404f6920a1"]; // Scandia Rent
  if (featureOrganizations.includes(organizationId)) return true;
  return false;
};

export const askSsn = (group) => {
  const featureGroups = [
    "stadinpakut",
    "pakunvuokraus",
    "prgroup",
    "vuokraapaku",
    "THERent",
    "nlp-group",
  ];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const askDriverSsn = (group) => {
  const featureGroups = ["vuokraapaku", "janne"];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const disableCreditcheck = (group) => {
  const featureGroups = [
    "khautovuokraus",
    "polareyllas",
    "joensuunkauhojat",
    "ebikerental",
    "jyrkila",
    "gnista",
    "rsteam",
    "huuma",
    "kauppi_leasing",
    "s-company",
    "jyvaskylakaupunki",
    "majakkawatersportslohja",
    "ms_vuokraus",
    "njob",
  ];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const showPortInstruction = (companyId) => {
  // ID of group rsteam company vesijetit
  return companyId === "f2b7b12a-b755-4751-8802-934e63fcd8db" ? true : false;
};

export const enableVismaSign = (env, group) => {
  if (env === "local" || env === "staging" || env === "dev2") {
    return true;
  }
  try {
    const featureGroups = process.env.REACT_APP_FEATURE_SIGN.split(" ");
    const enabled = featureGroups.includes(group);
    return enabled;
  } catch (e) {
    console.error(e);
    return false;
  }
};

// Higher limit of Visma Pay in cents
export const vismaPayMaxPayment = (group) => {
  // Visma pay maximum payment is higher for certain customers
  if (
    group === "prgroup" ||
    group === "freedomvuokraus" ||
    group === "caravankeidas" ||
    group === "caravanlandia" ||
    group === "zenrentals" ||
    group === "roberts" ||
    group === "autolandia" ||
    group === "vanstoori"
  ) {
    return 600000;
  }
  return 200000;
};

export const hideZeroPrices = (env, company) => {
  const featureCompanies = [
    "6aec4644-93bb-4bb3-bdc0-26f28a4d8cdf",
    "0781af03-dbcc-4b7f-aa37-ada4a1b09658", // jkl
    "7ba188b4-c6a7-4200-9579-97999e93699e", //jkl
  ];
  if (featureCompanies.includes(company?.id)) return true;
  return false;
};

export const replaceWorkIcon = (env, company) => {
  if (company?.id === "6aec4644-93bb-4bb3-bdc0-26f28a4d8cdf") return true;
  return false;
};

export const replaceVolumeIcon = (env, company) => {
  if (company?.group === "ebikerental") return true;
  return false;
};
// Don't show and require all the input fields
export const enableMinimalCustomerInput = (env, group) => {
  if (group === "joensuunkauhojat") return true;
  return false;
};

export const isDev = (env, group) => {
  if (env === "local") return true;
  return false;
};

export const enablePrivacyPolicy = (env, group) => {
  if (group === "joensuunkauhojat") return true;
  return false;
};

// Be careful with this setting, as it will not behave correctly if all Companys
// within the group use the same settings.
// If enabled, return a Company with wanted settings. (businessHours, feature flags..)
export const selectAllCompanies = (companies) => {
  const groups = window.URENT_APP_GROUPS;
  //const groups = ["ville"];
  if (!groups || groups.length > 1) return false;
  const group = groups[0];
  // debug
  //if (group === "ville") {
  //const companySettings = companies.find(
  //(c) => c.id === "e861d76e-cd62-4415-8b80-1eacd63249de"
  //);
  //return {
  //...companySettings,
  //id: "all",
  //};
  //}
  // Vuokraapaku
  if (group === "vuokraapaku") {
    // Get a first 24/7 company (for vuokraapaku only Sörnäinen with no 24/7 has disableOffHourReturn)
    const companySettings = companies.find((c) => !c.disableOffHourReturn);
    return {
      ...companySettings,
      id: "all",
    };
  }
  return false;
};

// DO NOT USE FOR NOW.
export const selectAllCompanyIds = (companies) => {
  const groups = window.URENT_APP_GROUPS;
  //const groups = ["ville"];
  if (!groups || groups.length > 1) return false;
  const group = groups[0];
  // debug
  //if (group === "ville") {
  //const filteredCompanies = companies.filter(
  //(c) =>
  //c.id === "e861d76e-cd62-4415-8b80-1eacd63249de" ||
  //c.id === "967c17a0-2cd2-44cb-9937-d52199261e41"
  //);
  //const companyIds = filteredCompanies.map((c) => c.id);
  //return companyIds;
  //}
  if (group === "vuokraapaku") {
    // Should now work with all Companys
    //const filteredCompanies = companies.filter((c) => !c.disableOffHourReturn);
    const companyIds = companies.map((c) => c.id);
    return companyIds;
  }
  return false;
};

// If customized label for payment on pickup is set, return the label. Otherwise false.
export const paymentOnPickupLabel = (group) => {
  if (
    group === "ebikerental" ||
    group === "majakkawatersports" ||
    group === "majakkawatersportslohja"
  ) {
    return "Maksa liikuntaedulla noudon yhteydessä. (ePassi, Smartum, Edenred, Eazybreak)";
  }
  if (
    group === "elämysristeilyt" ||
    group === "tampereensaunalautta" ||
    group === "freedomvuokraus"
  ) {
    return "Maksu myöhemmin laskulla";
  }

  return false;
};
//
// If customized label for differentDriver is set, return the label. Otherwise false.
export const differentDriverLabel = (group) => {
  if (group === "jyrkila") {
    return "Lisäkuljettaja";
  }
  return false;
};

export const uRentLogoVisibility = (group) => {
  if (!group) return true;
  if (group === "majakkawatersports" || group === "majakkawatersportslohja") {
    return false;
  }
  return true;
};

export const hideFilters = (group) => {
  if (group === "gnista") {
    return true;
  }
  return false;
};

export const hideCategories = (group) => {
  if (group === "gnista") {
    return true;
  }
  return false;
};

export const hideAdditionalServicesTitle = (group) => {
  if (group === "gnista") {
    return true;
  }
  return false;
};

// TODO
export const dateRangeTitle = (group) => {
  if (group === "gnista") {
    return "Timeframe custom title";
  }
  return "Timeframe default title";
};

export const disableAdditionalDriver = (group) => {
  const featureGroups = ["gnista", "huuma"];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const disableCustomerIsCompany = (group) => {
  if (group === "gnista") {
    return true;
  }
  return false;
};

export const setDisablePaymentMethodBilling = (group) => {
  const featureGroups = ["gnista", "janne"];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const setFixedReservationDuration = (id, companies) => {
  if (!companies) return;

  const featureCompanyIds = [
    "bd1ac06b-fc86-470f-8a85-9d3a07d7f3b1",
    "e5dab512-e238-41b9-9be8-35b0c31b0ddc",
    "9d4d978c-1150-11ed-861d-0242ac120002",
  ];

  const enabled = featureCompanyIds.includes(id);

  return enabled;
};

export const setFixedReservationTimeFrame = (id) => {
  const featureCompanyIds = [
    "a5b329e2-fb7e-11ec-b939-0242ac120002",
    "e6be247e-4cea-49f9-84ac-8d44e09722eb",
  ];
  const enabled = featureCompanyIds.includes(id);
  return enabled;
};

export const disableSentry = () => {
  const groups = window.URENT_APP_GROUPS;
  return groups && groups[0] === "zenrentals"; // Customers site has problem with event listeners if Sentry is on
};

export const enableBusinessWideReservation = (company) => {
  if (!company?.organizationId) return false;
  const dev_org = "9e615947-75c4-44cf-bd89-fd4917d83a11";
  const dev_org_gangsta = "d90a0808-7f16-41af-a374-0244e5fe9df1";
  // Check if any companyId matches dev_org or scandia_org
  const isBusinessWide = [dev_org, scandia_org, dev_org_gangsta].includes(
    company.organizationId
  );
  return isBusinessWide;
};

export const orderCompaniesAlphabetically = (company) => {
  if (company?.organizationId === scandia_org) {
    return true;
  }
  return false;
};

export const hideVouchers = (group) => {
  const featureGroups = ["kauppi_leasing", "jyvaskylakaupunki"];
  const enabled = featureGroups.includes(group);

  return enabled;
};
